import { useState, useEffect } from 'react'
import api, { IEmployeeImport, IPageInfo } from '@api'

export default function useEmployeeImportHistory() {
  const [imports, setImports] = useState<IEmployeeImport[]>([])
  const [loading, setLoading] = useState(true)
  const [loadingMore, setLoadingMore] = useState(false)
  const [pageInfo, setPageInfo] = useState<IPageInfo | null>(null)

  const load = () => {
    api.employee.import.list().then(({ imports, pageInfo }) => {
      setImports(imports)
      setPageInfo(pageInfo)
      setLoading(false)
    })
  }

  const loadMore = () => {
    setLoadingMore(true)
    api.employee.import
      .list(pageInfo?.endCursor)
      .then(({ imports: newImports, pageInfo: newPageInfo }) => {
        setImports([...imports, ...newImports])
        setPageInfo(newPageInfo)
        setLoading(false)
        setLoadingMore(false)
      })
  }

  useEffect(load, [])

  return { imports, loading, reload: load, pageInfo, loadMore, loadingMore }
}
